(function () {
    const share = document.querySelector('.Share');
    if (!share) return;

    const button = share.querySelector('.Share__button');

    function closeDropdown() {
        share.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
    }

    button.addEventListener('click', (e) => {
        e.stopPropagation();

        const isOpen = share.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', (e) => {
        if (!share.contains(e.target)) {
            closeDropdown();
        }
    });
})();